import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CardDataSetComponent } from './card-data-set.component';
import { CardComponent } from '../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { NgScrollbar } from 'ngx-scrollbar';
import { CardTitleRenderPipe } from './card-title-render.pipe';
import { CardDataSetDisablePipe } from './card-data-set-disable.pipe';
import { NgxVisibilityModule } from 'ngx-visibility';
import { CardImgRenderPipe } from './card-img-render.pipe';
import { CardBodyRenderPipe } from './card-body-render.pipe';
import { MatCardModule } from '@angular/material/card';
import { CardIconRenderPipe } from './card-icon-render.pipe';
import { CardListRenderPipe } from './card-list-render.pipe';
import { DurationTextModule } from '../duration-text';
import { FilterDataSetModule } from '../filter-data-set';
import {CardItenIconRenderPipe} from "./card-iten-icon-render.pipe";

@NgModule({
  declarations: [
    CardDataSetComponent,
    CardTitleRenderPipe,
    CardDataSetDisablePipe,
    CardImgRenderPipe,
    CardBodyRenderPipe,
    CardIconRenderPipe,
    CardItenIconRenderPipe,
  ],
  exports: [
    CardDataSetComponent,
    CardImgRenderPipe,
    CardBodyRenderPipe,
    CardTitleRenderPipe,
    CardIconRenderPipe,
    CardItenIconRenderPipe
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTableModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    NgScrollbar,
    MatRippleModule,
    NgxVisibilityModule,
    MatCardModule,
    NgOptimizedImage,
    DurationTextModule,
    FilterDataSetModule
  ]
})
export class CardDataSetModule {
}
